<template>
  <div id="safety-box">
    <h3 class="center">Türen &amp; Fenster Sicherheit</h3>
    <br>
    <div class="grid grid-24">
      <img class="justify-center col-0 above-sm-col-span-8 below-md-fill img-frame" src="@/assets/media/safety/head.jpeg"/>
      <div class="align-center col-0 above-sm-col-9 fill">
        <p>Wir bauen und montieren alle Arten von Fenstern, Haustüren sowie Türen für den Wohnbereich. Entweder als Maßanfertigung oder als Fertigsystem aus Holz, Aluminium oder Kunststoff mit Doppel- und Dreifach-Verglasung. Dabei legen wir besonders viel Wert auf Einbruchsschutz, Energieeffizienz und Schalldämmung. So können wir spezielle Sicherheitsbeschläge und Schlösser einbauen sowie nachrüsten, die mit einer Mehrpunktverriegelung bzw. mit Pilzkopfverriegelung, Bolzen und Schwenkriegeln arbeiten und einen gehobenen Einbruchsschutz garantieren. Auf Wunsch verwenden wir Produkte, die nach Sicherheitsstandard RC 1 bis RC 6 als einbruchshemmend zertifiziert sind. Auch selbstschließende Türen und motorisierte Türöffner, die über Funk ferngesteuert werden, können wir installieren.</p>
      </div>
    </div>
    <br>
    <br>

    <h3 class="center">Galerie</h3>
    <br>
    <image-gallery :images="galleryImages"/>
  </div>
</template>

<script>
export default {
  name: "Outside",
  data() {
    return {
      galleryImages:this.importImages()
    };
  },
  methods:{
    importImages(){
      function importAll(r) { return r.keys().sort().map(r); }
      var images = importAll(require.context('@/assets/media/safety', false, /img\d+\.(png|jpe?g|svg)$/));
      return images.map(i=>{return {src:i}})
    }
  }
};
</script>

<style>

</style>
